"use strict";
/**
 * ExportService - Exports offline submissions as CSV
 * Generates downloadable CSV file with all submission data
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportService = void 0;
class ExportService {
    /**
     * Export submissions to CSV file
     * Downloads CSV with all fields from submissions
     */
    static exportToCSV(submissions) {
        if (!submissions || submissions.length === 0) {
            console.warn('No submissions to export');
            return;
        }
        // CSV headers
        const headers = [
            'Timestamp',
            'First Name',
            'Last Name',
            'Email',
            'Phone',
            'Company',
            'Job Title',
            'Country',
            'Referral Source',
            'Fleet Size',
            'Opt In',
            'Estimated Distance',
            'Fuel Efficiency',
            'Work Days',
            'Idle Time',
            'Fuel Cost',
            'Idle Savings',
            'Optimisation Savings',
            'Driver Behaviour Savings',
            'Total Savings',
            'Carbon Reduction (MT)',
        ];
        // Convert submissions to CSV rows
        const rows = submissions.map((submission) => [
            new Date(submission.timestamp).toISOString(),
            this.escapeCSV(submission.contactData.first),
            this.escapeCSV(submission.contactData.last),
            this.escapeCSV(submission.contactData.email),
            this.escapeCSV(submission.contactData.phone),
            this.escapeCSV(submission.contactData.company),
            this.escapeCSV(submission.contactData.job),
            this.escapeCSV(submission.contactData.country),
            this.escapeCSV(submission.contactData.referral),
            this.escapeCSV(submission.contactData.fleetSize),
            submission.contactData.optin ? 'Yes' : 'No',
            submission.calculatorData.estimatedDistance.toString(),
            submission.calculatorData.fuelEfficiency.toString(),
            submission.calculatorData.workDays.toString(),
            submission.calculatorData.idleTime.toString(),
            submission.calculatorData.fuelCost.toString(),
            submission.results.idle.toString(),
            submission.results.optimization.toString(),
            submission.results.driverBehavior.toString(),
            submission.results.total.toString(),
            submission.results.carbon.toString(),
        ]);
        // Combine headers and rows
        const csvContent = [
            headers.join(','),
            ...rows.map((row) => row.join(',')),
        ].join('\n');
        // Create blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        // Generate filename with current date
        const now = new Date();
        const dateStr = now.toISOString().split('T')[0]; // YYYY-MM-DD
        const filename = `fleet-savings-submissions-${dateStr}.csv`;
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
    /**
     * Escape CSV field values (handle quotes and commas)
     */
    static escapeCSV(field) {
        if (field === null || field === undefined) {
            return '';
        }
        const fieldStr = field.toString();
        // If field contains comma, quote, or newline, wrap in quotes and escape quotes
        if (fieldStr.includes(',') || fieldStr.includes('"') || fieldStr.includes('\n')) {
            return `"${fieldStr.replace(/"/g, '""')}"`;
        }
        return fieldStr;
    }
}
exports.ExportService = ExportService;
